import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; //useNavigate
import swal from "sweetalert";
import Modal from "./childComponents/popups/Modal";
import Loading from "./childComponents/appComponents/Loading";
import InputField from "./childComponents/inputComponents/InputField";
import SelectField from "./childComponents/inputComponents/SelectField";
import { TbCurrencyNaira } from "react-icons/tb";
import { MdContentPasteSearch } from "react-icons/md";
import { AiFillPrinter } from "react-icons/ai";
import { RiUserSearchFill } from "react-icons/ri";

const Report = () => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BUTTON_NAME = "Search Report";

  const [allRecords, setAllRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      startDate: null,
      endDate: null,
    },
    select: {
      location: null,
    },
  });

  const [options, setOptions] = useState({
    location: [],
  });

  let attendance,
    salary,
    totalSalary,
    perDay,
    grandTotal,
    totalAttendance,
    allRecordimage,
    grandTotals,
    totalAttendances;

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  function getDaysInMonth(dateString) {
    let date = new Date(dateString); // Convert string to Date object
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // Convert zero-based month to 1-based

    return new Date(year, month, 0).getDate(); // Get last day of the month
  }

  // Reload Page
  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: true,
  });

  // General useState
  const [generalState, setGeneralState] = useState({
    totalCharges: null,
    displayMessages: null,
    searchDateDisplay: null,
  });

  // Open Dialogue Box
  const [dialogueState, setDialogueState] = useState({
    modalType: false,
    modalTitle: null,
    trigger: false,
    editpost: null,
    searchDates: null,
    searchScript: null,
  });

  // Fetch the first day of the current month
  function getFirstDay() {
    const firstDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    return firstDay.toISOString().split("T")[0];
  }

  // Fetch the Current Date
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  function getDaysLetter(dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) throw new Error("Invalid date format");

    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }

  function extractColumn(arr, column) {
    return arr.map((x) => x[column]);
  }

  /* All records */
  useEffect(() => {
    (async () => await fetchReportData())();
  }, [dialogueState.editpost]);

  //Query constructor
  const queryConstructorString = () => {
    let query = "?";
    let messages = "";
    const initializeSearchDate = {};
    let searchDateDisplays = "";
    let searchWithDate = 0;

    // Helper function to handle query string updates
    const addToQuery = (condition, queryKey, value, label) => {
      if (condition) {
        query += `${queryKey}[eq]=${value}&`;
        messages += `${label.toUpperCase()}: ${value} | `;
      }
    };

    const { input, select } = formData;
    // Add query parameters dynamically

    addToQuery(
      true,
      "fileNumber",
      localStorage.getItem("NumberType"),
      "FileNo."
    );

    addToQuery(select.location, "location", select.location, "Location");

    if (input.startDate) {
      query += `date[gte]=${input.startDate}&`;
      messages += `START DATE: ${getDaysLetter(input.startDate)} | `;
      searchDateDisplays += getDaysLetter(input.startDate) + " / ";
      initializeSearchDate.startDate = input.startDate;
      searchWithDate = 1;
    }

    if (input.endDate) {
      query += `date[lte]=${input.endDate}&`;
      messages += `END DATE: ${getDaysLetter(input.endDate)} | `;
      searchDateDisplays += getDaysLetter(input.endDate);
      initializeSearchDate.endDate = input.endDate;
      searchWithDate = 1;
    }

    if (query === "?" || searchWithDate === 0) {
      query = `?date[gte]=${getFirstDay()}&date[lte]=${getCurrentDate()}&fileNumber[eq]=${localStorage.getItem(
        "NumberType"
      )}&`;
      messages =
        "START DATE: " +
        getDaysLetter(getFirstDay()) +
        " | END DATE: " +
        getDaysLetter(getCurrentDate());
      searchDateDisplays =
        getDaysLetter(getFirstDay()) + " / " + getDaysLetter(getCurrentDate());

      initializeSearchDate.startDate = getFirstDay();
      initializeSearchDate.endDate = getCurrentDate();
    } else {
      query += "name[ne]=" + null;
    }

    return { query, messages, initializeSearchDate, searchDateDisplays };
  };

  async function fetchReportData() {
    const { query, messages, initializeSearchDate, searchDateDisplays } =
      queryConstructorString();

    // Display Current Search Request Parameters as a Message
    setGeneralState((prev) => ({
      ...prev,
      searchDateDisplay: searchDateDisplays,
      displayMessages: messages,
    }));

    try {
      await axios.get("sanctum/csrf-cookie");

      const responses = await Promise.all([
        axios.get(`${BASE_URL}reportpage${query}`),
        axios.get(`${BASE_URL}inputlocation?status[eq]=Active`),
      ]);

      const [reportData, locationData] = responses;

      if (reportData.data.status === 200) {
        if (reportData.data.allData.length === 0) {
          swal(
            "Oops!",
            "Sorry! we did not find any information in the report",
            "warning"
          );
        } else {
          // Store a sample of Current Search Request Parameters for Dialogue Box
          setDialogueState((prev) => ({
            ...prev,
            searchScript: query,
            searchDates: initializeSearchDate,
          }));
          setGeneralState((prev) => ({
            ...prev,
            totalCharges: reportData.data.TotalCharges,
          }));

          setAllRecords(reportData.data.allData);
          setFilteredRecords(reportData.data.allData);
          setAllDepartments(reportData.data.AvailableDepartments);
        }

        setReloadState({
          btnLoading: BUTTON_NAME,
          loading: false,
        });
      }

      // populate the select menu
      const populateSelect = (colume, columeObject, columeName) => {
        if (columeObject.data.status === 200) {
          return setOptions((prev) => ({
            ...prev,
            [colume]: extractColumn(columeObject.data.allData, columeName),
          }));
        } else if (columeObject.data.status === 500) {
          swal("Oops!", columeObject.data.message, "error");
        }
      };
      populateSelect("location", locationData, "location");
    } catch (error) {
      swal("Error", "There were no Data found!", "error");
    }
  }
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const newRecords = allRecords.slice(firstIndex, lastIndex);
  const npage = Math.ceil(allRecords.length / recordsPerPage);
  const number = [...Array(npage + 1).keys()].slice(1);

  // Search
  async function searchData(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      btnLoading: <div>Processsing...</div>,
    }));
    fetchReportData();
  }
  const handleFilter = (event) => {
    let text = event.target.value;

    let newData = filteredRecords.filter(
      (row) =>
        row.name.toLowerCase().includes(text.toLowerCase()) ||
        row.fileNumber.toLowerCase().includes(text.toLowerCase())
    );
    if (event) {
      setAllRecords(newData.length > 0 ? newData : allRecords);
    }
  };

  async function printPaySlip(event, posts) {
    event.preventDefault();

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalPaySlips",
      modalTitle: "PRINT PAY SLIP",
      trigger: true,
      editpost: posts,
    }));
  }

  async function expandRegister(event, posts) {
    event.preventDefault();

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalUserRegisterDetails",
      modalTitle: "USER REGESTRY DETAILS",
      trigger: true,
      editpost: posts,
    }));
  }

  async function printReportSheet(event) {
    event.preventDefault();

    setDialogueState((prev) => ({
      ...prev,
      modalType: "ModalReportSheet",
      modalTitle: "PRINT PAY SHEET",
      trigger: true,
      editpost: allRecords,
    }));
  }

  if (reloadState.loading) {
    return <Loading message01={"Loading..."} />;
  }

  // Clean the Form
  const formCleanner = () => {
    setDialogueState((prev) => ({
      ...prev,
      modalType: false,
      modalTitle: null,
      trigger: false,
      editpost: null,
      searchDates: null,
      searchScript: null,
    }));

    fetchReportData();
  };

  function numberWithCommas(x) {
    if (!x) {
      x = 0;
    }
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <>
      {/* modal Type, Title of the Modal Box, triger the modal, convay all the data inputs to be edithed to child */}
      <Modal
        modalType={dialogueState.modalType}
        titles={dialogueState.modalTitle}
        trigger={dialogueState.trigger}
        editpost={dialogueState.editpost}
        searchDate={dialogueState.searchDates}
        formCleanner={formCleanner}
        searchScript={dialogueState.searchScript}
      />

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-secondary p-3">
                <i className="fa fa-search"></i> SEARCH REPORT
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <InputField
                    label="Start Date"
                    name="startDate"
                    size="3"
                    placeholder="Please Select Start Date"
                    required=""
                    value={formData.input.startDate}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  <InputField
                    label="End Date"
                    name="endDate"
                    size="3"
                    placeholder="Please Select End Date"
                    required=""
                    value={formData.input.endDate}
                    type="date"
                    onChange={updateFormData}
                    icon="fa fa-calendar-check-o"
                  />

                  <SelectField
                    label="Location"
                    name="location"
                    size="3"
                    placeholder="Please Select An Office Location"
                    required=""
                    value={formData.select.location}
                    options={options.location}
                    switchOptions={0}
                    onChange={updateFormData}
                    icon="fa fa-location-arrow"
                  />

                  <div className="col-lg-3">
                    <div className="row form-group mt-3">
                      <div className="col-lg-6">
                        <Link
                          className="btn btn-iceberg col-12 mt-4"
                          onClick={softreload}
                          to="/user/report"
                        >
                          <i className="fa fa-refresh"></i>
                        </Link>
                      </div>
                      <div className="col-lg-6">
                        <button
                          className="btn btn-iceberg col-12 mt-4"
                          onClick={searchData}
                        >
                          <div className=" d-flex justify-content-center">
                            <i className="fa fa-search pt-1 pe-2"></i>
                            {reloadState.btnLoading}
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-secondary p-3">
                <MdContentPasteSearch style={{ fontSize: "20px" }} /> SUMMARY
                SHEET
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div
                    className="col-lg-9 py-3 p-4"
                    style={{ fontSize: "15px" }}
                  >
                    <div className="row col-lg mt-3">
                      <div className="col-lg-3 border-bottom">
                        <b>Salary Total:</b>
                      </div>
                      <div className="col-lg-4 border-bottom">
                        <b>
                          ₦
                          {numberWithCommas(localStorage.getItem("grandTotal"))}
                        </b>{" "}
                        (Staff Salary)
                      </div>

                      <div className="col-lg-3 border-bottom">
                        <b>Total Staff Attendance:</b>
                      </div>
                      <div className="col-lg-2 border-bottom">
                        <b>{localStorage.getItem("totalAttendance")}</b>
                      </div>
                    </div>

                    {
                      //allDepartments

                      allDepartments.map((depart, index) => {
                        return (
                          <div className="row col-lg mt-3">
                            <div className="col-lg-3 border-bottom">
                              <b>{depart.departmentName}:</b>
                            </div>
                            <div className="col-lg-4 border-bottom">
                              <b>₦{numberWithCommas(depart.serviceCharges)}</b>{" "}
                              (Service Charge)
                            </div>

                            <div className="col-lg-3 border-bottom">
                              <b></b>
                            </div>
                            <div className="col-lg-2 border-bottom">
                              <b></b>
                            </div>
                          </div>
                        );
                      })
                    }

                    <div className="row col-lg mt-3">
                      <div className="col-lg-3 border-bottom ">
                        <b style={{ color: "red" }}>GRAND TOTAL:</b>
                      </div>
                      <div className="col-lg-4 border-bottom">
                        <b style={{ color: "red" }}>
                          ₦
                          {numberWithCommas(
                            parseInt(generalState.totalCharges) +
                              parseInt(localStorage.getItem("grandTotal"))
                          )}
                        </b>
                      </div>

                      <div className="col-lg-3 border-bottom"></div>
                      <div className="col-lg-2 border-bottom"></div>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="row">
                      <button
                        className="col-lg-12 btn btn-primary"
                        onClick={printReportSheet}
                        data-toggle="modal"
                        data-target="#exampleModal"
                      >
                        <div className="col-lg-12 mt-2">
                          <AiFillPrinter style={{ fontSize: "20px" }} />
                          Print Sheet
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-lg-fluid m-3">
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card">
              <div className="card-header text-white bg-secondary p-3">
                <MdContentPasteSearch style={{ fontSize: "20px" }} /> ALL STAFF
                <span className="float-end me-3">
                  {generalState.displayMessages}
                </span>
              </div>
              <div className="card-body">
                <div className="row m-1">
                  <div>
                    <div style={{ display: "flex", float: "right" }}>
                      <input
                        type="text"
                        name="searchData"
                        placeholder="...Employee or FileNo."
                        style={{ padding: "5px 7px" }}
                        onChange={handleFilter}
                      />
                    </div>
                  </div>
                  <div style={{ width: "100%", overflowX: "scroll" }}>
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          {[
                            { action: "Action", width: "15%", color: "black" },
                            {
                              action: "Employee",
                              width: "15%",
                              color: "black",
                            },
                            { action: "Image", width: "5%", color: "black" },
                            {
                              action: "Department",
                              width: "10%",
                              color: "black",
                            },
                            {
                              action: "Attendance",
                              width: "10%",
                              color: "black",
                            },
                            {
                              action: "Daily Rate",
                              width: "10%",
                              color: "black",
                            },
                            { action: "Salary", width: "10%", color: "black" },
                            { action: "SubTotal", width: "10%", color: "red" },
                            { action: "Date", width: "15%", color: "black" },
                          ].map((column, index) => (
                            <th
                              key={index}
                              scope="col"
                              style={{
                                width: column.width,
                                color: column.color,
                              }}
                            >
                              {column.action}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {newRecords.map((allRecord, index) => {
                          attendance = allRecord.shift;
                          salary = allRecord.salary;
                          
                          let startDate =
                            generalState.searchDateDisplay.split(" / ");
                          let noDays = getDaysInMonth(startDate[0]);
                          perDay = Math.ceil(salary / noDays); //30

                          totalSalary = perDay * attendance;

                          grandTotal = Number(
                            localStorage.getItem("grandTotal")
                          );
                          if (index === 0) {
                            grandTotal = 0;
                            totalAttendance = 0;
                          }

                          grandTotals =
                            Number(grandTotal) + Number(totalSalary);
                          totalAttendances =
                            Number(totalAttendance) + Number(attendance);

                          localStorage.setItem("grandTotal", grandTotals);

                          localStorage.setItem(
                            "totalAttendance",
                            totalAttendances
                          );

                          grandTotal = Number(
                            localStorage.getItem("grandTotal")
                          );

                          totalAttendance = Number(
                            localStorage.getItem("totalAttendance")
                          );

                          if (
                            allRecord.imageIn === null ||
                            allRecord.imageIn === "null"
                          ) {
                            allRecordimage =
                              "upload/admin_passports/1673523387.jpg";
                          } else {
                            allRecordimage = allRecord.imageIn;
                          }

                          return (
                            <tr key={index}>
                              <th>
                                <button
                                  type="button"
                                  className="btn btn-primary me-3"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={(event) =>
                                    printPaySlip(event, allRecord)
                                  }
                                >
                                  <AiFillPrinter style={{ fontSize: "20px" }} />
                                  PaySlip
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-iceberg me-3"
                                  data-toggle="modal"
                                  data-target="#exampleModal"
                                  onClick={(event) =>
                                    expandRegister(event, allRecord)
                                  }
                                >
                                  <RiUserSearchFill
                                    style={{ fontSize: "20px" }}
                                  />
                                  Details
                                </button>
                              </th>

                              <td>
                                {allRecord.name}
                                <br />
                                <em style={{ color: "red" }}>
                                  Staff No.: {allRecord.fileNumber}
                                </em>
                              </td>
                              <td>
                                <Link
                                  to={BACKEND_URL + allRecordimage}
                                  target="_blank"
                                >
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    src={BACKEND_URL + allRecordimage}
                                    alt={allRecordimage || "Image"}
                                    width={60}
                                    height={70}
                                  />
                                </Link>
                              </td>
                              <td>{allRecord.department}</td>
                              <td>{attendance + " Day(s)"}</td>
                              <td>
                                <TbCurrencyNaira style={{ fontSize: "20px" }} />
                                {numberWithCommas(perDay) + " Per Day"}
                              </td>
                              <td>
                                <TbCurrencyNaira style={{ fontSize: "20px" }} />
                                {numberWithCommas(totalSalary)}
                              </td>
                              <td>
                                <b>
                                  <TbCurrencyNaira
                                    style={{ fontSize: "20px" }}
                                  />
                                  {numberWithCommas(grandTotal)}
                                </b>
                              </td>
                              <td>{generalState.searchDateDisplay}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <nav>
                    <ul className="pagination">
                      <li className="page-item">
                        <Link to="#" className="page-link" onClick={prePage}>
                          Prev
                        </Link>
                      </li>

                      {number.map((n, i) => (
                        <li
                          className={`page-item ${
                            currentPage === n ? "active" : ""
                          }`}
                          key={i}
                        >
                          <Link
                            to="#"
                            className="page-link"
                            onClick={() => changeCPage(n)}
                          >
                            {n}
                          </Link>
                        </li>
                      ))}

                      <li className="page-item">
                        <Link to="#" className="page-link" onClick={nextPage}>
                          Next
                        </Link>
                      </li>
                      <li className="page-item ps-3 pe-3 pt-1 bg-primary text-white">
                        Total Count: {allRecords.length}
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  function softreload() {
    window.location.reload();
  }

  /* Pagination*/
  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    if (currentPage !== firstIndex) {
      setCurrentPage(id);
    }
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }
  /* End of Pagination*/
};

export default Report;
